import ProductListEntity from '@ts/core/src/modules/productlist/productlist.entity'
import { setCookie, parseCookies } from 'nookies'

export const useLockedProductLists = (options?: { unlockCallback?: () => void }) => {
  // store product list id
  //
  const { PRODUCT_LISTS_UNLOCKED, PRODUCT_LISTS_META } = parseCookies()

  const unlockedListIds = PRODUCT_LISTS_UNLOCKED?.split(',') ?? []
  const productListMeta = PRODUCT_LISTS_META ? JSON?.parse(PRODUCT_LISTS_META) : {}

  const unlockProductList = (data: ProductListEntity, returnUrl: string) => {
    const productListIds = [...(PRODUCT_LISTS_UNLOCKED ?? []), data?.id]?.join(',')
    const productListMeta = {
      [data?.id]: {
        returnUrl,
        pricelist: data?.priceList,
      },
    }

    setCookie(null, 'PRODUCT_LISTS_UNLOCKED', productListIds, {
      path: '/',
      maxAge: 60 * 24 * 60 * 60,
    })
    setCookie(null, 'PRODUCT_LISTS_META', JSON.stringify(productListMeta), {
      path: '/',
      maxAge: 630 * 24 * 60 * 60,
    })

    options?.unlockCallback && options?.unlockCallback()
  }

  const getReturnUrlFromPricelist = (pricelist: string) => {
    if (!pricelist) return null

    const productListMetaArray: { returnUrl: string; pricelist: string }[] =
      Object.values(productListMeta)

    const productList = productListMetaArray?.find(pl => pl?.pricelist === pricelist)

    return productList?.returnUrl
  }

  return { unlockedListIds, unlockProductList, getReturnUrlFromPricelist }
}
